import React from "react";
import DataSlider from "./pure-slider";

export default ({ label, domain, suffix, step, isTheme, skipMargin, ticks, value, handleChange }) => {

    return <div className={skipMargin ? "" : "mb-4"}>
        <label className="paylixecommerce-label mb-3">
            {label}&nbsp;&nbsp;
        </label>
        <DataSlider
            domain={domain}
            step={step}
            suffix={suffix}
            ticks={ticks}
            value={[value]}
            isTheme={isTheme}
            receiveValue={handleChange}
        />
    </div>
}
